// printLogic.js
import React, { useEffect } from "react";
export const HandlePrint = ({ contentRef, hideModal }) => {

  useEffect(() => {
    hideModal();
  }, [])
  const PrintCSS = `
@media print{
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Poppins,sans-serif !important;
}
.container-wrapper-box {
  display: flex;
  justify-content: center;
  padding: 20px 30px 0px 30px;
  flex-direction: column;
}

/* General Styles */
.user-data {
  padding: 0;
}

.logo-container {
  margin-bottom: 20px;
  margin-left: -10px;
}

.agency-logo {
  /* width: 100%; Add your desired width here */
  width: 100px;
  margin-left: 10px;
}

/* Contact Info Styles */

.text-16 {
  font-size: 16px;
}
.text-15 {
  font-size: 15px;
}
.text-14 {
  font-size: 14px;
}
.text-12 {
  font-size: 12px;
}
.text-13 {
  font-size: 13px;
}
.text-11 {
  font-size: 11px;
}
.text-18 {
  font-size: 18px;
}

.text-semibold {
  font-weight: 600;
}
.text-bold {
  font-weight: bold;
}
h4,
h3 {
  margin: 0;
}

.phone-number {
  color: lightblue;
}

.contact-info {
  margin-top: 20px;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);  
  margin-bottom: 20px;
}

.contact-details {
  display: flex;
  gap: 100px;
}

.contact-label {
    display: flex;
    align-items: center;
    gap: 5px;
}
.contact-text {
  margin: 10px !important;
  color: #6e7887;
}

.margin-10 {
  margin: 10px !important;
}

.contact-value {
  color: #164897;
}

.risk-assessment-header {
  display: flex;
  justify-content: center;
  padding-top: 20px;
  font-weight: bold;
}

.risk-assessment-header-text {
  display: flex;
  justify-content: left;
  padding-top: 20px;
  font-weight: bold;
  margin-left: -50px;
}

.risk-assessment-header h2 {
  text-decoration: underline;
  padding-bottom: 5px;
}

.risk-assessment-text {
  text-align: center;
}

.risk-amount {
  display: flex;
  justify-content: center;
  padding: 16px;
}

.risk-amount h1 {
  padding: 10px 20px;
  border: 1px solid #c8c5c5;
  border-radius: 15px;
}

.limit-content {
  display: flex;
  justify-content: space-between;
}

.email-text {
  color: #19a776;
}

.phone-text {
  color: #164897;
}

/* Limit Box Styles */
.limit-container {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.limit-box {
  border: 1.5px solid #c8c5c5;
}

.text-box {
  width: 100%;
  padding: 20px 30px;
  text-align: center;
}

.icon-box-others {
  border-left: 1.55px solid #c8c5c5;
  border-right: 1.55px solid #c8c5c5;
  border-bottom: 1.55px solid #c8c5c5;
}

.icon-box {
  border: 1.55px solid #c8c5c5;
}

.icon-container {
  display: flex;
  justify-content: flex-start;
}
.icon-container > span {
  padding: 10px;
}

.box-gap {
  gap: 20px;
}

.make-div-centered {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/*  more css */

.myd-block {
  display: block;
}

.my-flex-row {
  display: flex;
  flex-direction: row;
}

.h-center {
  width:130px;
  display: flex;
  align-items: center;
}

.icon-img {
  height: 20px;
  width: 20px;
  margin: 0 2px;
}

.page-break {
  page-break-after: always;
}

.life-stage-container {
  display: flex;
  justify-content: flex-start;
  margin-bottom:10px;
}

/* General table styling */
table.bordered-table {
  width: 100%;
  border-collapse: collapse; /* Collapse borders so there's no gap */
  font-size: 14px;
}

/* Column width adjustments */
table.bordered-table th:nth-child(1),
table.bordered-table td:nth-child(1) {
  width: 50%; /* First column takes 50% */
}

table.bordered-table th:nth-child(2),
table.bordered-table td:nth-child(2) {
  width: 50%; /* Second column takes 50% */
  font-weight: bold;
}

/* Styling for each table cell */
table.bordered-table th,
table.bordered-table td {
  padding: 10px;
  border-left: 2px solid grey; /* Left border for columns */
  border-right: 2px solid grey; /* Top border for rows */
  border-top: 2px solid grey; /* Top border for rows */
  border-bottom: 2px solid grey; /* Top border for rows */
}

/* Specific Styles for the Second Table (bordered-table-100) */

table.bordered-table-assets-account {
  width: 100%;
  border-collapse: collapse; /* Collapse borders so there's no gap */
  font-size: 14px;
}

/* Styling for each table cell */
table.bordered-table-assets-account td {
  padding: 10px;
  border-left: 2px solid #0003; /* Left border for columns */
  border-right: 2px solid #0003; /* Top border for rows */
  border-top: 2px solid #0003; /* Top border for rows */
  border-bottom: 2px solid #0003; /* Top border for rows */
}

/* Column width adjustments */
table.bordered-table-assets-account th:nth-child(1),
table.bordered-table-assets-account td:nth-child(1) {
  width: 75%; /* First column takes 50% */
}

table.bordered-table-assets-account th:nth-child(2),
table.bordered-table-assets-account td:nth-child(2) {
  width: 25%; /* Second column takes 50% */
  font-weight: bold;
}

/* CSS Wrapping the tables */

.table-wrapper {
  margin-top: 20px;
  padding: 25px 20px;
  border-radius: 5px;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2); /* Adding shadow */
}
}

/* CSS only for bg page while printing */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Poppins,sans-serif !important;
}
.container-wrapper-box {
  display: flex;
  justify-content: center;
  padding: 20px 30px 0px 30px;
  flex-direction: column;
}

/* General Styles */
.user-data {
  padding: 0;
}

.logo-container {
  margin-bottom: 20px;
  margin-left: -10px;
}

.agency-logo {
  /* width: 100%; Add your desired width here */
  margin-left:10px;
}

/* Contact Info Styles */

.text-16 {
  font-size: 16px;
}
.text-15 {
  font-size: 15px;
}
.text-14 {
  font-size: 14px;
}
.text-12 {
  font-size: 12px;
}
.text-13 {
  font-size: 13px;
}
.text-11 {
  font-size: 11px;
}
.text-18 {
  font-size: 18px;
}

.text-semibold {
  font-weight: 600;
}
.text-bold {
  font-weight: bold;
}
h4,
h3 {
  margin: 0;
}

.phone-number {
  color: lightblue;
}

.contact-info {
  margin-top: 20px;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);  
  margin-bottom: 20px;
}

.contact-details {
  display: flex;
  gap: 100px;
}

.contact-label {
    display: flex;
    align-items: center;
    gap: 5px;
}
.contact-text {
  margin: 10px !important;
  color: #6e7887;
}

.margin-10 {
  margin: 10px !important;
}

.contact-value {
  color: #164897;
}

.risk-assessment-header {
  display: flex;
  justify-content: center;
  padding-top: 20px;
  font-weight: bold;
}
.risk-assessment-header-text {
  display: flex;
  justify-content: left;
  padding-top: 20px;
  font-weight: bold;
  margin-left: -50px;
}

.risk-assessment-header h2 {
  text-decoration: underline;
  padding-bottom: 5px;
}

.risk-assessment-text {
  text-align: center;
}

.risk-amount {
  display: flex;
  justify-content: center;
  padding: 16px;
}

.risk-amount h1 {
  padding: 10px 20px;
  border: 1px solid #c8c5c5;
  border-radius: 15px;
}

.limit-content {
  display: flex;
  justify-content: space-between;
}

.email-text {
  color: #19a776;
}

.phone-text {
  color: #164897;
}

/* Limit Box Styles */
.limit-container {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.limit-box {
  border: 1.5px solid #c8c5c5;
}

.text-box {
  width: 100%;
  padding: 20px 30px;
  text-align: center;
}

.icon-box-others {
  border-left: 1.55px solid #c8c5c5;
  border-right: 1.55px solid #c8c5c5;
  border-bottom: 1.55px solid #c8c5c5;
}

.icon-box {
  border: 1.55px solid #c8c5c5;
}

.icon-container {
  display: flex;
  justify-content: flex-start;
}
.icon-container > span {
  padding: 10px;
}

.box-gap {
  gap: 20px;
}

.make-div-centered {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/*  more css */

.myd-block {
  display: block;
}

.my-flex-row {
  display: flex;
  flex-direction: row;
}

.h-center {
  width:130px;
  display: flex;
  align-items: center;
}

.icon-img {
  height: 20px;
  width: 20px;
  margin: 0 2px;
}

.page-break {
  page-break-after: always;
}

.life-stage-container {
  display: flex;
  justify-content: flex-start;
  margin-bottom:10px;
}

/* General table styling */
table.bordered-table {
  width: 100%;
  border-collapse: collapse; /* Collapse borders so there's no gap */
  font-size: 14px;
}

/* Column width adjustments */
table.bordered-table th:nth-child(1),
table.bordered-table td:nth-child(1) {
  width: 50%; /* First column takes 50% */
}

table.bordered-table th:nth-child(2),
table.bordered-table td:nth-child(2) {
  width: 50%; /* Second column takes 50% */
  font-weight: bold;
}

/* Styling for each table cell */
table.bordered-table th,
table.bordered-table td {
  padding: 10px;
  border-left: 2px solid #0003; /* Left border for columns */
  border-right: 2px solid #0003; /* Top border for rows */
  border-top: 2px solid #0003; /* Top border for rows */
  border-bottom: 2px solid #0003; /* Top border for rows */
}

/* Specific Styles for the Second Table (bordered-table-100) */

table.bordered-table-assets-account {
  width: 100%;
  border-collapse: collapse; /* Collapse borders so there's no gap */
  font-size: 14px;
}

/* Styling for each table cell */
table.bordered-table-assets-account td {
  padding: 10px;
  border-left: 2px solid #0003; /* Left border for columns */
  border-right: 2px solid #0003; /* Top border for rows */
  border-top: 2px solid #0003; /* Top border for rows */
  border-bottom: 2px solid #0003; /* Top border for rows */
}

/* Column width adjustments */
table.bordered-table-assets-account th:nth-child(1),
table.bordered-table-assets-account td:nth-child(1) {
  width: 75%; /* First column takes 50% */
}

table.bordered-table-assets-account th:nth-child(2),
table.bordered-table-assets-account td:nth-child(2) {
  width: 25%; /* Second column takes 50% */
  font-weight: bold;
}

/* CSS Wrapping the tables */

.table-wrapper {
  margin-top: 20px;
  padding: 25px 20px;
  border-radius: 5px;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2); /* Adding shadow */
}
`
  const printContent = contentRef.current.innerHTML;
  const printWindow = window.open('', '_blank');

  printWindow.document.open();
  printWindow.document.write(
    '<html><head><title>Print Bfile</title><link href="https://fonts.googleapis.com/css?family=Roboto:300,400,700" rel="stylesheet"> <link rel="stylesheet"  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"/><style>' +
    PrintCSS +
    "</style></head><body>" +
    `${printContent}` +
    "</body></html>"
  );
  printWindow.document.close();
  printWindow.print();
  return (
    <div>
    </div>
  )
};



// WEBPACK FOOTER //
// ./src/components/print-pdf/printLogic.js